const POPUP_SELECTOR = '.js-banner-work-popup'
const POPUP_DELAY = 5000
const POPUP_SHOWN_KEY = 'bannerWorkPopupShown'

function isPopupShown() {
  return sessionStorage.getItem(POPUP_SHOWN_KEY) === 'true'
}

function markPopupAsShown() {
  sessionStorage.setItem(POPUP_SHOWN_KEY, 'true')
}

export function handleBannerWorkPopup() {
  const popup = document.querySelector(POPUP_SELECTOR)

  if (!popup || typeof $ === 'undefined' || !$.fancybox || isPopupShown()) return

  setTimeout(() => {
    $.fancybox.open({
      src: POPUP_SELECTOR,
      type: 'inline'
    }, {
      buttons: ['close'],
      baseClass: 'banner-work-fancybox',
      clickOutside: 'close',
      clickSlide: 'close',
      smallBtn: true,
      touch: false
    })
    markPopupAsShown()
  }, POPUP_DELAY)
}
